module.exports = __webpack_public_path__ + "static/media/maximo_perrone.635b6c77.jpg";